<form>
  <div mat-dialog-content>
    <mat-icon class="headerIcon">{{ icon }}</mat-icon>
    <mat-label>{{ titleString }}</mat-label>
      @if (table == 'player_data') {
        <app-video-link videoLink="importExportScene"></app-video-link>
      }
      @if (table == 'resources') {
        <app-video-link videoLink="importExportResource"></app-video-link>
      }
    <div class="pull-right">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <div class="dlg-drag-handle" cdkDragHandle>
          <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
            <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </div>
      </div>
    </div>
    <div style="padding-top: 30px"></div>
    <mat-divider></mat-divider>
    <br/>
    <div fxLayout="column" fxLayoutAlign="space-evenly stretch">
      @if (isLoading) {
        <div>
          <app-loading [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
        </div>
      }
      @if (!isLoading) {
        <div>
          <div fxLayout="row" fxLayoutAlign="start center">
            <a (click)="exportClick()" mat-raised-button [disabled]="totalSelected === 0">
              <mat-icon class="iconAction1 rotateExport">call_merge</mat-icon>
              <mat-label class="fontSize">{{ 'general.export' | transloco }}</mat-label>
            </a>
            <h1>selected for export: {{ this.totalSelected }}</h1>
          </div>
          <br/>
          <mat-divider></mat-divider>
          <br/>
          <div fxLayout="row" fxLayoutAlign="start center">
            <a (click)="importClick()" mat-raised-button [disabled]="importSelected === 0">
              <mat-icon class="rotateImport">call_merge</mat-icon>
              <mat-label class="fontSize">{{ 'general.import' | transloco }}</mat-label>
            </a>
            <h1>available for import {{ importSelected }}</h1>
          </div>
        </div>
      }
    </div>
    <div style="padding-top: 30px"></div>

  </div>
  <!--    <button mat-flat-button color="accent"  type="submit" class="btn btn-default" [disabled]="!notesForm.valid">Submit</button>-->
</form>

